import { cn } from '@ais-ui/utils';

interface ErrorDisplayProps {
  message?: string;
  srcImage?: string;
  children?: React.ReactNode;
  className?: string;
}

export const ErrorDisplay = ({
  message = 'Something went wrong',
  srcImage = '/404_not_found_error_bro.png',
  children,
  className,
}: ErrorDisplayProps) => {
  return (
    <div
      className={cn(
        'flex flex-col w-full justify-center items-center self-center',
        className
      )}
    >
      <img
        className="w-96 h-96 object-contain"
        src={srcImage}
        alt="Error occurred"
      />
      <div className="flex flex-col items-center justify-center my-4 space-y-2 w-[60%]">
        <div className="text-muted-foreground text-center">{message}</div>
      </div>
      <div className="flex w-[60%] justify-center items-center">{children}</div>
    </div>
  );
};
